import { Outlet, Link } from 'react-router-dom';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/logos/solid/white/horizontal1.svg';
import { UserContext } from '../../context/user.context';
import Footer from '../../components/footer/footer.component';
import UserInformation from '../../components/user-information/user-information.component';
import HeaderComponent from '../../components/header/header.component';
import Loader from '../../components/loader/loader.component';

const Navigation = () => {
  const { currentUser } = useContext(UserContext);
  const { pathname } = useLocation();
  const isTripEnsurancePage =
    pathname === '/' || pathname === '/trip-ensurance';
  const [isLoading, setIsLoading] = useState(isTripEnsurancePage);

  useEffect(() => {
    if (isTripEnsurancePage) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  }, [pathname]);

  return (
    <Fragment>
      <HeaderComponent user={currentUser} />
      {/* {currentUser ? (
        <UserInformation className="nav-link" />
      ) : (
        <Link className="nav-link" to="/authentication">
          Login
        </Link>
      )} */}

      {isLoading ? (
        <Loader className="main-loader" />
      ) : (
        <>
          <Outlet />
          <Footer />
        </>
      )}
    </Fragment>
  );
};

export default Navigation;
